import React from 'react';
import ReactDOM from 'react-dom/client';
import CashregisterProduct from './CashregisterProduct';
import CashregisterProductVariation from './CashregisterProductVariation';

class CashregisterCatalog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      categoryId: props.categoryId !== 'null' ? parseInt(props.categoryId, 10) : null,
      sellId: props.sellId !== 'null' ? parseInt(props.sellId, 10) : null,
      returnUrl: props.returnUrl !== 'null' ? props.returnUrl : null,
      currentCategories: [],
      currentCategory: {},
      currentProductTocategories: [],
      paramShowimages: false,
      paramStock: false,
      paramVariations: false
    };
  }

  componentDidMount() {
    fetch('/api/_cashregisterindex', {
      headers: {
        Authorization: 'gestiaweb'
      }
    })
      .then(res => res.json())
      .then(result => {
        this.setState({
          categories: result.categories,
          currentCategories: this.state.categoryId ? result.categories.filter(category => category.categoryParentId === this.state.categoryId) : result.categories.filter(category => !category.categoryParentId),
          currentCategory: this.state.categoryId ? result.categories.find(category => category.id === this.state.categoryId) : {},
          paramShowimages: result.paramShowimages,
          paramVariations: result.paramVariations,
          paramStock: result.paramStock
        });

        if (this.state.categoryId) {
          this.loadProducts(this.state.categoryId);
        }
      });
  }

  /**
   * Chargement des produits d'une catégorie via l'appel de l'API
   * @param {number} categoryId - Identifiant de la catégorie
   */
  loadProducts(categoryId) {
    fetch(`/api/_cashregisterproducts?categoryId=${categoryId}`, {
      headers: {
        Authorization: 'gestiaweb'
      }
    })
      .then(res => res.json())
      .then(result => {
        this.setState({
          currentProductTocategories: result.currentProductTocategories
        });
      });
  }

  /**
   * Lors du clic sur une catégorie
   * @param {number} categoryId - Identifiant de la catégorie
   */
  onClickOnCategory(categoryId) {
    var currentCategories = this.state.categories.filter(category => {
        return categoryId ? category.categoryParentId === categoryId : !category.categoryParentId;
      }),
      currentCategory = categoryId ? this.state.categories.find(category => category.id === categoryId) : {};

    this.setState({
      currentCategory,
      categoryId,
      currentCategories,
      currentProductTocategories: []
    });

    if (categoryId) {
      this.loadProducts(categoryId);
    }
  }

  /**
   * Lors du clic sur un produit sans déclinaison
   * @param {number} productId - Identifiant du produit
   */
  onClickOnProduct(productId) {
    document.location.href = this.getUrl(productId);
  }

  /**
   * Lors du changement de valeur dans la liste déroulante des déclinaisons du produit
   * @param {object} product - Produit
   * @param {PointerEvent} e - Evènement associé au changement de valeur dans la liste déroulante des déclinaisons du produit
   */
  onChangeOnProductVariation(product, e) {
    document.location.href = this.getUrl(product.id, parseInt(e.target.value, 10));
  }

  /**
   * Permet de récupérer l'url pour l'ajout d'un produit dans une note
   * @param {number} productId - Identifiant du produit
   * @param {number} variationId - Identifiant de la déclinaison
   * @returns {string}
   */
  getUrl(productId, variationId) {
    var url = `/sell-product/_addcashregister/${productId}?sidebarreduce=true`;

    if (this.state.sellId) {
      url += `&sellId=${this.state.sellId}`;
    }

    if (this.state.returnUrl) {
      url += `&returnurl=${this.state.returnUrl}`;
    }

    if (this.state.categoryId) {
      url += `&categoryId=${this.state.categoryId}`;
    }

    if (variationId) {
      url += `&variationId=${variationId}`;
    }

    return url;
  }

  render() {
    return (
      <div>
        <h5 className="cashregister__title">
          <span className="material-icons">category</span>Catégories
        </h5>
        <div className="grid grid--has-5-child grid--8-gap">
          {Object.keys(this.state.currentCategory).length !== 0 ? (
            <a className="btn btn--main-color" href="#" onClick={this.onClickOnCategory.bind(this, this.state.currentCategory.categoryParentId)}>
              <i className="material-icons">arrow_back</i>Retour
            </a>
          ) : null}
          {this.state.currentCategories.map((category, index) => (
            <a style={this.state.paramShowimages ? { backgroundImage: `url(${category.thumbnail || '/images/NO_THUMBNAIL.webp'})` } : null} key={index} href="#" className="cashregister__category" onClick={this.onClickOnCategory.bind(this, category.id)}>
              <h5 className="cashregister__card-name">{category.name}</h5>
            </a>
          ))}
        </div>
        {this.state.currentProductTocategories.length ? (
          <div>
            <div className="space--8"></div>
            <h5 className="cashregister__title">
              <icon className="material-icons">storefront</icon>Produits dans "{this.state.currentCategory.name}"
            </h5>
            <div className="grid grid--has-5-child grid--8-gap">
              {this.state.currentProductTocategories.map((productTocategory, index) => (
                <div key={index}>{productTocategory.product.product_variations.length ? <CashregisterProductVariation key={index} onChangeOnProductVariation={this.onChangeOnProductVariation.bind(this, productTocategory.product)} product={productTocategory.product} paramStock={this.state.paramStock} paramShowimages={this.state.paramShowimages} /> : <CashregisterProduct key={index} onClickOnProduct={() => this.onClickOnProduct(productTocategory.product.id)} product={productTocategory.product} paramStock={this.state.paramStock} paramShowimages={this.state.paramShowimages} />}</div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

var CashregisterCatalogNode = document.getElementById('cashregister-catalog');
if (CashregisterCatalogNode) {
  var root = ReactDOM.createRoot(CashregisterCatalogNode);
  root.render(<CashregisterCatalog categoryId={CashregisterCatalogNode.getAttribute('data-categoryid') || null} sellId={CashregisterCatalogNode.getAttribute('data-sellid') || null} returnUrl={CashregisterCatalogNode.getAttribute('data-returnurl') || null} />);
}
